<template>
<!-- :class="show ? 'show' : 'hide'" -->
<div   
  class="festivals">
  <div>注意：</div>
  <div>（1）双11大促期间短信发送时间：10月9日、10月10日、10月14日-10月16日、10月30日-11月1日、11月9日-11月11日 9:00-24:00 ；10月11日-10月13日、10月17日-10月29日、11月2日—11月8日 9:00-21:00 ；11月12日起恢复正常，即 09:00-20:00（*包含普通短信、富信、卡片短信）
  </div>
  <div>
    （2）10月9日-11月11日双11大促期频控规则：同一店铺2天内给同一手机号发送商家营销短信的条数不超过1条;每个手机号每1天只能收到5条商家营销短信,每2天只能收到10条商家营销短信（*商家营销短信包括普通短信、富信、卡片短信）
  </div>
</div>
</template>

<script>

export default {
  name: '' ,
  components: {},
  props:{
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {},
  created() {

  },
  mounted() {
    let now = new Date(Date.now()).getTime();
    let end = new Date('2023-11-12 00:00:00').getTime();
    console.log('now: ' + now + ' end: ' + end)
    if(now > end){
      this.show = false;
    }

  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.hide{
  display: none;
}
.festivals{
  width:100%;
  line-height:25px;
  color:red;
  margin-left:50px;
  margin-top:30px;
  margin-bottom:5px;
}
</style>